import 'css-chunksrc/client/scenes/planzoneVirtualResourceAddition/virtualResourceForm/styles.scss';export default {
  "virtualResourceForm": "_virtualResourceForm_1udah_1",
  "row": "_row_1udah_8",
  "group": "_group_1udah_19",
  "label": "_label_1udah_23",
  "input": "_input_1udah_29",
  "textArea": "_textArea_1udah_46"
};